export default {
	"8a7c658f1509e28d4eedc3cf176bc35f": "抱歉，支付方式已發生變化"
}
